import React, { useContext, useState, useEffect } from 'react';

import { DataContext } from '../../../../stores/covering-table-store';
import TagsInput from './TagsInput';
import { useDebounce } from '../../shared/FilterEventHelpers';

const DescriptionFilters = () => {
    const {
        store: { descriptionFilters, descriptionSearchSuggestions },
        dispatch,
    } = useContext(DataContext);

    const [values, setValues] = useState(descriptionFilters);

    const debouncedValues = useDebounce(values, 500);

    useEffect(() => {
        if (debouncedValues) {
            dispatchValues();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValues]);

    useEffect(() => {
        if (!(descriptionFilters && descriptionFilters.length)) {
            setValues([]);
            dispatchValues();
        } else {
            setValues(descriptionFilters);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionFilters]);

    const dispatchValues = () => {
        if (values.length === 0) {
            setValues([]);
        }
        dispatch({ type: 'DESCRIPTION_FILTERS', payload: values });
    };

    return (
        <div className='description-filters pt-1'>
            <TagsInput values={values} setValues={setValues} dispatchValues={dispatchValues} suggestions={descriptionSearchSuggestions} />
        </div>
    );
};

export default DescriptionFilters;
